module.exports = __webpack_public_path__ + "static/background-b3f329620f81eea8b84089314c4bf0f6.png";